/* LuElla's Boutique theme scripts */
(function () {
  'use strict';

  var L = window.LuEllas || { routes: {}, strings: {} };
  var R = L.routes;
  var S = L.strings;
  // Handle of the seasonal sale collection this page belongs to ('' outside sales).
  var SALE = L.sale || '';

  /* ------------------------------------------------------------------ */
  /* Helpers                                                             */
  /* ------------------------------------------------------------------ */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || L.moneyFormat || '${{amount}}';
    function delimit(n, precision, thousands, decimal) {
      precision = precision === undefined ? 2 : precision;
      var parts = (n / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousands || ','));
      return dollars + (parts[1] ? (decimal || '.') + parts[1] : '');
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function fetchJSON(url, options) {
    options = options || {};
    options.headers = Object.assign({ 'Accept': 'application/json' }, options.headers || {});
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var msg = (data && (data.description || data.message)) || 'Something went wrong. Please try again.';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function postJSON(url, body) {
    return fetchJSON(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function getCart() { return fetchJSON(R.cartJs); }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.setAttribute('data-count', String(count));
    });
  }

  function refreshCartCount() {
    return getCart().then(function (cart) { updateCartCount(cart.item_count); return cart; }).catch(function () {});
  }

  var toastTimer;
  function showToast(text) {
    var toast = $('#CartToast');
    if (!toast) return;
    $('.toast__text', toast).textContent = text || S.added;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 5000);
  }

  function uid() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }

  /* ------------------------------------------------------------------ */
  /* Cart separation: regular shop vs. each school's seasonal sale        */
  /* Cart types: 'regular' or 'seasonal:<sale collection handle>'         */
  /* ------------------------------------------------------------------ */
  function cartTypeOf(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var saleItem = cart.items.find(function (item) {
      return item.properties && item.properties._order_type === 'seasonal';
    });
    if (!saleItem) return 'regular';
    return 'seasonal:' + (saleItem.properties._sale || '');
  }

  // Resolves true when it's OK to add an item of `type`.
  function ensureCartType(type) {
    return getCart().then(function (cart) {
      var current = cartTypeOf(cart);
      if (!current || current === type) return true;
      return askAboutConflict(type, current);
    });
  }

  function askAboutConflict(type, current) {
    var dialog = $('#CartConflictDialog');
    var message;
    if (type === 'regular') message = S.regularConflict;          // adding shop item, cart has sale items
    else if (current === 'regular') message = S.seasonalConflict; // adding sale item, cart has shop items
    else message = S.otherSaleConflict;                           // adding sale item, cart has another sale
    if (!dialog || typeof dialog.showModal !== 'function') {
      return Promise.resolve(window.confirm(message + '\n\nEmpty your cart and add this item?'))
        .then(function (ok) { return ok ? postJSON(R.cartClear, {}).then(function () { return true; }) : false; });
    }
    $('[data-conflict-text]', dialog).textContent = message;
    dialog.showModal();
    return new Promise(function (resolve) {
      function cleanup() {
        replaceBtn.removeEventListener('click', onReplace);
        cancelBtn.removeEventListener('click', onCancel);
        dialog.removeEventListener('cancel', onCancel);
      }
      function onReplace() {
        cleanup();
        dialog.close();
        postJSON(R.cartClear, {}).then(function () { resolve(true); }).catch(function () { resolve(false); });
      }
      function onCancel() { cleanup(); dialog.close(); resolve(false); }
      var replaceBtn = $('[data-conflict-replace]', dialog);
      var cancelBtn = $('[data-conflict-cancel]', dialog);
      replaceBtn.addEventListener('click', onReplace);
      cancelBtn.addEventListener('click', onCancel);
      dialog.addEventListener('cancel', onCancel);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Mobile menu drawer                                                   */
  /* ------------------------------------------------------------------ */
  function initDrawer() {
    var drawer = $('#MenuDrawer');
    if (!drawer) return;
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      $$('.js-menu-open').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var closeBtn = $('.js-menu-close', drawer);
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      $$('.js-menu-open').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastFocus) lastFocus.focus();
    }
    $$('.js-menu-open').forEach(function (b) { b.addEventListener('click', open); });
    $$('.js-menu-close', drawer).forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ------------------------------------------------------------------ */
  /* Product gallery (swipe + dots/thumbs)                                */
  /* ------------------------------------------------------------------ */
  function initGallery(root) {
    var track = $('.gallery__track', root);
    if (!track) return null;
    var slides = $$('.gallery__slide', track);
    var navButtons = $$('[data-slide-to]', root);
    function setCurrent(index) {
      navButtons.forEach(function (b) {
        b.setAttribute('aria-current', String(parseInt(b.getAttribute('data-slide-to'), 10) === index));
      });
    }
    function goTo(index) {
      var slide = slides[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setCurrent(index);
    }
    navButtons.forEach(function (b) {
      b.addEventListener('click', function () { goTo(parseInt(b.getAttribute('data-slide-to'), 10)); });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        setCurrent(index);
        ticking = false;
      });
    });
    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        var index = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
        if (index > -1) goTo(index);
      }
    };
  }

  /* ------------------------------------------------------------------ */
  /* Variant helpers                                                      */
  /* ------------------------------------------------------------------ */
  function readProductJSON(root) {
    var el = $('[data-product-json]', root);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function findVariant(product, selected) {
    return product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return selected[i] === undefined || selected[i] === opt; });
    });
  }

  function collectProperties(container) {
    // Builds a { name: value } object from properties[...] inputs inside container.
    var props = {};
    $$('input, select, textarea', container).forEach(function (el) {
      var m = el.name && el.name.match(/^properties\[(.+)\]$/);
      if (!m) return;
      var key = m[1];
      if (el.type === 'checkbox') {
        if (el.checked) props[key] = el.value;
        else if (!(key in props)) props[key] = 'No';
        return;
      }
      if (el.type === 'radio') {
        if (el.checked) props[key] = el.value;
        return;
      }
      if (el.type === 'hidden') {
        if (!(key in props)) props[key] = el.value;
        return;
      }
      if (el.value !== '') props[key] = el.value;
    });
    return props;
  }

  function validate(container) {
    var fields = $$('[required]', container);
    for (var i = 0; i < fields.length; i++) {
      var el = fields[i];
      if (el.disabled || el.closest('[hidden]')) continue;
      if (typeof el.checkValidity === 'function' && !el.checkValidity()) {
        if (typeof el.reportValidity === 'function') el.reportValidity();
        el.focus();
        return false;
      }
    }
    return true;
  }

  /* ------------------------------------------------------------------ */
  /* Regular product form                                                 */
  /* ------------------------------------------------------------------ */
  function initProduct(root) {
    var product = readProductJSON(root);
    var form = $('form[data-product-form]', root);
    if (!product || !form) return;
    var gallery = initGallery(root);
    var idInput = $('input[name="id"]', form);
    var selects = $$('[data-option-index]', root);
    var priceEl = $('[data-price]', root);
    var compareEl = $('[data-compare-price]', root);
    var skuEl = $('[data-sku]', root);
    var submit = $('[data-add-button]', form);
    var submitLabel = submit ? $('[data-add-label]', submit) : null;
    var errorEl = $('[data-form-error]', root);
    var qtyInput = $('[data-qty-input]', root);

    function selected() { return selects.map(function (s) { return s.value; }); }

    function update() {
      var variant = findVariant(product, selected());
      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitLabel) submitLabel.textContent = S.unavailable;
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (skuEl) skuEl.textContent = variant.sku ? 'SKU: ' + variant.sku : '';
      if (submit) {
        submit.disabled = !variant.available;
        if (submitLabel) submitLabel.textContent = variant.available ? S.addToCart : S.soldOut;
      }
      if (variant.featured_media && gallery) gallery.showMedia(variant.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', update); });
    initQty(root);

    form.addEventListener('submit', function (e) {
      // File uploads (e.g. photo ornaments) use a normal form post so the file goes with it.
      var fileInput = $$('input[type="file"]', form).find(function (f) { return f.files && f.files.length; });
      if (fileInput) {
        if (!validate(form)) e.preventDefault();
        return;
      }
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      if (!validate(form)) return;
      var props = collectProperties(form);
      var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      if (submit) submit.setAttribute('aria-busy', 'true');
      ensureCartType('regular').then(function (ok) {
        if (!ok) return null;
        var item = { id: parseInt(idInput.value, 10), quantity: qty };
        if (Object.keys(props).length) item.properties = props;
        return postJSON(R.cartAdd, { items: [item] }).then(function () {
          refreshCartCount();
          showToast(S.added);
        });
      }).catch(function (err) {
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      }).then(function () {
        if (submit) submit.removeAttribute('aria-busy');
      });
    });

    update();
  }

  function initQty(root) {
    $$('[data-qty]', root).forEach(function (wrap) {
      var input = $('input', wrap);
      $$('[data-qty-step]', wrap).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-qty-step'), 10);
          var min = parseInt(input.getAttribute('min') || '1', 10);
          input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Seasonal product form (one size or multi-size grid)                  */
  /* ------------------------------------------------------------------ */
  function initSeasonal(root) {
    var product = readProductJSON(root);
    if (!product) return;
    initGallery(root);

    var sizeIndex = parseInt(root.getAttribute('data-size-index'), 10);
    var otherSelects = $$('[data-option-index]', root);
    var sizeSelect = $('[data-size-select]', root);
    var singleQtyInput = $('[data-single-qty]', root);
    var singleWrap = $('[data-single]', root);
    var multiWrap = $('[data-multi]', root);
    var rows = $$('[data-size-row]', root);
    var fieldTemplate = $('template[data-field-template]', root);
    var hasTagFields = !!(fieldTemplate && fieldTemplate.content.querySelector('[data-tag-field]'));
    var shirtList = $('[data-shirt-list]', root);
    var shirtItems = $('[data-shirt-items]', root);
    var addon = $('[data-addon]', root);
    var addonItems = addon ? $('[data-addon-items]', addon) : null;
    var addonVariantId = addon ? parseInt(addon.getAttribute('data-addon-variant'), 10) : null;
    var addonPrice = addon ? parseInt(addon.getAttribute('data-addon-price'), 10) : 0;
    var addonLabel = addon ? addon.getAttribute('data-addon-label') : 'Customization';
    var summaryEl = $('[data-summary]', root);
    var addonTotalEl = $('[data-addon-total]', root);
    var submit = $('[data-seasonal-submit]', root);
    var errorEl = $('[data-form-error]', root);
    var priceEl = $('[data-price]', root);
    var multiMode = false;
    var qtyBySize = {};
    var addonState = {}; // shirt index -> { on: bool, text: '' }
    var shirtFieldState = {}; // shirt index -> { name: value }

    var sizeValues = [];
    if (sizeIndex > -1) {
      sizeValues = rows.length
        ? rows.map(function (r) { return r.getAttribute('data-size-row'); })
        : productOptionValues(sizeIndex);
    }

    function productOptionValues(index) {
      var seen = [];
      product.variants.forEach(function (v) { if (seen.indexOf(v.options[index]) === -1) seen.push(v.options[index]); });
      return seen;
    }

    function selectedOthers() {
      var sel = [];
      otherSelects.forEach(function (s) { sel[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
      return sel;
    }

    function variantFor(size) {
      var sel = selectedOthers();
      if (sizeIndex > -1) sel[sizeIndex] = size;
      return findVariant(product, sel);
    }

    function currentQuantities() {
      if (multiMode) return Object.assign({}, qtyBySize);
      var q = {};
      if (sizeIndex > -1 && sizeSelect) {
        q[sizeSelect.value] = Math.max(1, parseInt(singleQtyInput.value, 10) || 1);
      } else {
        q['__one'] = Math.max(1, parseInt(singleQtyInput.value, 10) || 1);
      }
      return q;
    }

    function styleLabel() {
      return otherSelects.map(function (s) { return s.value; }).join(' / ');
    }

    function shirts() {
      var list = [];
      var q = currentQuantities();
      var order = sizeIndex > -1 ? sizeValues : ['__one'];
      order.forEach(function (size) {
        for (var i = 0; i < (q[size] || 0); i++) list.push({ size: size });
      });
      return list;
    }

    function updateRows() {
      rows.forEach(function (row) {
        var size = row.getAttribute('data-size-row');
        var variant = variantFor(size);
        var available = !!(variant && variant.available);
        var qty = qtyBySize[size] || 0;
        if (!available && qty) { qty = 0; qtyBySize[size] = 0; }
        row.classList.toggle('is-unavailable', !available);
        row.classList.toggle('has-qty', qty > 0);
        $('output', row).textContent = qty;
        $('[data-step="-1"]', row).disabled = qty <= 0;
        $('[data-step="1"]', row).disabled = !available;
        var priceSmall = $('[data-row-price]', row);
        if (priceSmall) priceSmall.textContent = variant ? (available ? formatMoney(variant.price) : S.soldOut) : S.unavailable;
      });
      if (sizeSelect) {
        $$('option', sizeSelect).forEach(function (opt) {
          var v = variantFor(opt.value);
          opt.disabled = !(v && v.available);
        });
      }
    }

    function saveShirtState() {
      if (shirtItems) {
        $$('[data-shirt]', shirtItems).forEach(function (el) {
          var idx = el.getAttribute('data-shirt');
          shirtFieldState[idx] = {};
          $$('input, select, textarea', el).forEach(function (f) {
            if (!f.name) return;
            if (f.type === 'checkbox' || f.type === 'radio') {
              if (f.checked) shirtFieldState[idx][f.name + '::' + f.value] = true;
            } else if (f.type !== 'hidden') {
              shirtFieldState[idx][f.name] = f.value;
            }
          });
        });
      }
      if (addonItems) {
        $$('[data-addon-item]', addonItems).forEach(function (el) {
          var idx = el.getAttribute('data-addon-item');
          addonState[idx] = {
            on: $('input[type="checkbox"]', el).checked,
            text: $('input[type="text"]', el).value
          };
        });
      }
    }

    function sizeName(size) {
      if (size === '__one') return '';
      var opt = sizeSelect ? $$('option', sizeSelect).find(function (o) { return o.value === size; }) : null;
      return opt ? opt.textContent.trim() : size;
    }

    function renderShirts() {
      saveShirtState();
      var list = shirts();
      var label = styleLabel();

      if (shirtList && shirtItems) {
        shirtItems.innerHTML = '';
        var needsShirtFields = hasTagFields && list.length > 0;
        shirtList.hidden = !needsShirtFields;
        if (needsShirtFields) {
          list.forEach(function (shirt, i) {
            var n = i + 1;
            var box = document.createElement('div');
            box.className = 'shirt';
            box.setAttribute('data-shirt', String(n));
            var title = document.createElement('div');
            title.className = 'shirt__title';
            title.innerHTML = '<span class="dot dot--' + ['pink', 'teal', 'yellow', 'mint', 'rose'][i % 5] + '" style="--s:9px"></span>';
            title.appendChild(document.createTextNode('Shirt ' + n + [label, sizeName(shirt.size)].filter(Boolean).map(function (t, j) { return (j === 0 ? ' · ' : ', ') + t; }).join('')));
            box.appendChild(title);
            var fields = fieldTemplate.content.cloneNode(true);
            $$('[id]', fields).forEach(function (el) {
              var oldId = el.id;
              el.id = oldId + '-s' + n;
              var lbl = fields.querySelector('label[for="' + oldId + '"]');
              if (lbl) lbl.setAttribute('for', el.id);
            });
            // Give each shirt its own radio group: properties[Color] -> properties[Color__s2]
            $$('input[type="radio"]', fields).forEach(function (el) { el.name = el.name.replace(/\]$/, '__s' + n + ']'); });
            box.appendChild(fields);
            var saved = shirtFieldState[String(n)];
            if (saved) {
              $$('input, select, textarea', box).forEach(function (f) {
                if (!f.name) return;
                var base = f.name.replace(/__s\d+\]$/, ']');
                if (f.type === 'checkbox' || f.type === 'radio') {
                  f.checked = !!saved[f.name + '::' + f.value];
                } else if (f.type !== 'hidden' && saved[base] !== undefined) {
                  f.value = saved[base];
                } else if (f.type !== 'hidden' && saved[f.name] !== undefined) {
                  f.value = saved[f.name];
                }
              });
            }
            shirtItems.appendChild(box);
          });
        }
      }

      if (addon && addonItems) {
        addonItems.innerHTML = '';
        addon.hidden = list.length === 0;
        list.forEach(function (shirt, i) {
          var n = i + 1;
          var state = addonState[String(n)] || { on: false, text: '' };
          var item = document.createElement('div');
          item.className = 'addon__item';
          item.setAttribute('data-addon-item', String(n));
          var checkId = 'addon-check-' + n;
          var inputId = 'addon-text-' + n;
          var shirtText = 'Shirt ' + n + (sizeName(shirt.size) ? ' · ' + sizeName(shirt.size) : '');
          item.innerHTML =
            '<label class="addon__check" for="' + checkId + '">' +
              '<input class="check" type="checkbox" id="' + checkId + '"' + (state.on ? ' checked' : '') + '>' +
              '<span></span>' +
            '</label>' +
            '<div class="addon__input field"' + (state.on ? '' : ' hidden') + '>' +
              '<label class="visually-hidden" for="' + inputId + '"></label>' +
              '<input class="field__input" type="text" id="' + inputId + '" placeholder="Name or number for this shirt"' + (state.on ? ' required' : '') + '>' +
            '</div>';
          $('.addon__check span', item).textContent = shirtText;
          $('label.visually-hidden', item).textContent = addonLabel + ' for ' + shirtText;
          $('input[type="text"]', item).value = state.text || '';
          var check = $('input[type="checkbox"]', item);
          check.addEventListener('change', function () {
            var wrap = $('.addon__input', item);
            var text = $('input[type="text"]', item);
            wrap.hidden = !check.checked;
            text.required = check.checked;
            if (check.checked) text.focus();
            updateSummary();
          });
          addonItems.appendChild(item);
        });
      }
      updateSummary();
    }

    function addonCount() {
      if (!addonItems) return 0;
      return $$('[data-addon-item] input[type="checkbox"]', addonItems).filter(function (c) { return c.checked; }).length;
    }

    function updateSummary() {
      var q = currentQuantities();
      var total = 0;
      var parts = [];
      Object.keys(q).forEach(function (size) {
        if (!q[size]) return;
        total += q[size];
        parts.push((size === '__one' ? '' : size + ' ×') + q[size]);
      });
      var label = styleLabel();
      if (summaryEl) summaryEl.textContent = total ? (label ? label + ': ' : '') + parts.join(', ') : 'No sizes selected';
      var count = addonCount();
      if (addonTotalEl) addonTotalEl.textContent = count ? count + ' custom · +' + formatMoney(count * addonPrice) : '';
      if (submit) {
        submit.disabled = total === 0;
        submit.textContent = total ? 'Add ' + total + (total === 1 ? ' item' : ' items') + ' to order' : 'Choose your sizes';
      }
      if (priceEl && !multiMode && sizeSelect) {
        var v = variantFor(sizeSelect.value);
        if (v) priceEl.textContent = formatMoney(v.price);
      }
    }

    function setMode(multi) {
      multiMode = multi;
      if (multi) {
        qtyBySize = {};
        sizeValues.forEach(function (s) { qtyBySize[s] = 0; });
        if (sizeSelect) qtyBySize[sizeSelect.value] = Math.max(1, parseInt(singleQtyInput.value, 10) || 1);
      }
      if (singleWrap) singleWrap.hidden = multi;
      if (multiWrap) multiWrap.hidden = !multi;
      updateRows();
      renderShirts();
    }

    // Wire up controls
    otherSelects.forEach(function (s) { s.addEventListener('change', function () { updateRows(); renderShirts(); }); });
    if (sizeSelect) sizeSelect.addEventListener('change', renderShirts);
    if (singleQtyInput) singleQtyInput.addEventListener('change', renderShirts);
    initQty(root);
    $$('[data-open-multi]', root).forEach(function (b) { b.addEventListener('click', function () { setMode(true); }); });
    $$('[data-close-multi]', root).forEach(function (b) { b.addEventListener('click', function () { setMode(false); }); });
    rows.forEach(function (row) {
      var size = row.getAttribute('data-size-row');
      $$('[data-step]', row).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-step'), 10);
          qtyBySize[size] = Math.max(0, (qtyBySize[size] || 0) + step);
          updateRows();
          renderShirts();
        });
      });
    });

    function buildItems() {
      var list = shirts();
      var label = styleLabel();
      var groupedQty = {};
      var items = [];
      var shirtBoxes = shirtItems ? $$('[data-shirt]', shirtItems) : [];
      var addonBoxes = addonItems ? $$('[data-addon-item]', addonItems) : [];

      list.forEach(function (shirt, i) {
        var variant = shirt.size === '__one' ? findVariant(product, selectedOthers()) : variantFor(shirt.size);
        if (!variant) return;
        var fieldProps = shirtBoxes[i] ? collectProperties(shirtBoxes[i]) : {};
        // Radio inputs were renamed per shirt; restore the original property names.
        Object.keys(fieldProps).forEach(function (k) {
          var clean = k.replace(/__s\d+$/, '');
          if (clean !== k) { fieldProps[clean] = fieldProps[k]; delete fieldProps[k]; }
        });
        var addonBox = addonBoxes[i];
        var addonOn = addonBox && $('input[type="checkbox"]', addonBox).checked;
        var addonText = addonBox ? $('input[type="text"]', addonBox).value.trim() : '';
        var individual = Object.keys(fieldProps).length > 0 || addonOn;

        if (!individual) {
          groupedQty[variant.id] = (groupedQty[variant.id] || 0) + 1;
          return;
        }
        var props = Object.assign({}, fieldProps, { _order_type: 'seasonal', _sale: SALE });
        var group = null;
        if (addonOn && addonVariantId) {
          group = uid();
          props._group = group;
          props[addonLabel] = addonText;
        }
        items.push({ id: variant.id, quantity: 1, properties: props });
        if (group) {
          var forText = product.title + ' (' + [label, sizeName(shirt.size)].filter(Boolean).join(', ') + ')';
          var addonProps = { 'For': forText, _order_type: 'seasonal', _sale: SALE, _group: group };
          addonProps[addonLabel] = addonText;
          items.push({ id: addonVariantId, quantity: 1, properties: addonProps });
        }
      });

      Object.keys(groupedQty).forEach(function (id) {
        items.unshift({ id: parseInt(id, 10), quantity: groupedQty[id], properties: { _order_type: 'seasonal', _sale: SALE } });
      });
      return items;
    }

    if (submit) {
      submit.addEventListener('click', function () {
        if (errorEl) errorEl.hidden = true;
        if (!validate(root)) return;
        var items = buildItems();
        if (!items.length) return;
        submit.setAttribute('aria-busy', 'true');
        ensureCartType('seasonal:' + SALE).then(function (ok) {
          if (!ok) return null;
          return postJSON(R.cartAdd, { items: items }).then(function () {
            refreshCartCount();
            showToast(S.added);
          });
        }).catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        }).then(function () { submit.removeAttribute('aria-busy'); });
      });
    }

    updateRows();
    renderShirts();
  }

  /* ------------------------------------------------------------------ */
  /* Cart page                                                            */
  /* ------------------------------------------------------------------ */
  function initCart() {
    var form = $('#CartForm');
    if (!form) return;
    initQty(form);
    $$('[data-qty-input]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        var key = input.getAttribute('data-key');
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        postJSON(R.cartChange, { id: key, quantity: qty }).then(function () { window.location.reload(); });
      });
    });
    $$('[data-remove]', form).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var group = btn.getAttribute('data-group');
        var key = btn.getAttribute('data-key');
        btn.disabled = true;
        getCart().then(function (cart) {
          var updates = {};
          cart.items.forEach(function (item) {
            if (item.key === key) updates[item.key] = 0;
            if (group && item.properties && item.properties._group === group) updates[item.key] = 0;
          });
          return postJSON(R.cartUpdate, { updates: updates });
        }).then(function () { window.location.reload(); }).catch(function () { window.location.reload(); });
      });
    });
    var note = $('[data-cart-note]', form);
    if (note) {
      var noteTimer;
      note.addEventListener('input', function () {
        clearTimeout(noteTimer);
        noteTimer = setTimeout(function () { postJSON(R.cartUpdate, { note: note.value }).catch(function () {}); }, 500);
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Collection sort                                                      */
  /* ------------------------------------------------------------------ */
  function initSort() {
    $$('[data-sort-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                 */
  /* ------------------------------------------------------------------ */
  function initRecommendations() {
    $$('[data-recommendations][data-url]').forEach(function (el) {
      if (el.children.length) return;
      fetch(el.getAttribute('data-url'))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }

  function init() {
    initRecommendations();
    initDrawer();
    initSort();
    initCart();
    $$('[data-product-root]').forEach(initProduct);
    $$('[data-seasonal-root]').forEach(initSeasonal);
    var toastClose = $('#CartToast');
    if (toastClose) toastClose.addEventListener('click', function (e) { if (e.target === toastClose) toastClose.hidden = true; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
